import { StyledSection, StyledHeading, StyledSubHeading } from './OfferTypeConfirm.styles';

function OfferTypeConfirm({ message1, message2 }) {
  return (
    <StyledSection>
      <StyledHeading>{message1}</StyledHeading>
      <StyledSubHeading>{message2}</StyledSubHeading>
    </StyledSection>
  );
}

export default OfferTypeConfirm;
